export default __webpack_public_path__ + "static/media/img_07.2bc39d08.png";